import useThriveAuth from 'hooks/useThriveAuth'
import styles from './index.module.scss'
import capitalize from 'lodash/capitalize'
import classNames from 'classnames'

const NavUserDetails: React.FC = () => {
  const { user } = useThriveAuth()

  return (
    <div className={styles.nav_user_details_container}>
      <div
        className={classNames(
          styles.nav_user_details_name,
          'd-flex align-items-center'
        )}
      >
        {user.firstName && (
          <div className="fs-16 text-truncate">{`${capitalize(
            user.firstName
          )} ${capitalize(user.lastName)}`}</div>
        )}
      </div>
      <div className="mr-1 text-slate-gray fs-14 text-truncate">
        {user.email}
      </div>
    </div>
  )
}

export default NavUserDetails
